import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { selectIsOnboardingComplete, selectMeetStatus } from "~/store";

export const Route = createFileRoute("/_app/")({
  component: App,
});

function App() {
  const meetStatus = useSelector(selectMeetStatus);
  const isOnboardingComplete = useSelector(selectIsOnboardingComplete);
  const navigate = useNavigate();

  // biome-ignore lint/correctness/useExhaustiveDependencies: navigate is stable from useNavigate
  useEffect(() => {
    // Redirect based on meetStatus
    if (meetStatus === "created" && isOnboardingComplete)
      navigate({ to: "/dashboard/results/highlights", replace: true });

    if (meetStatus === "finished" && isOnboardingComplete)
      navigate({ to: "/dashboard/results/highlights", replace: true });

    if (meetStatus === "pending")
      navigate({ to: "/account/create", search: { step: 2 }, replace: true });
  }, [meetStatus, isOnboardingComplete]);

  return null;
}
